<template>
  <div class="d-flex justify-center">
    <sf-large-button v-if="ssoSettings.ssoLoginExclusive" block @click="openSsoPopup">
      {{ $t('signIn') }}
    </sf-large-button>
    <sf-text-button v-else size="small" @click="openSsoPopup">
      {{ $t('login_sso') }}
    </sf-text-button>
  </div>
</template>

<script setup lang="ts">
import SfLargeButton from '@/components/button/SfLargeButton.vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import useSsoPopup from '@/modules/authentication/useSsoPopup'
import { SsoSettings } from '@/types/index'
import { PropType } from 'vue'

const props = defineProps({
  ssoSettings: {
    type: Object as PropType<SsoSettings>,
    required: true
  }
})

const { openSsoPopup: openPopup } = useSsoPopup()

const openSsoPopup = () => {
  openPopup(props.ssoSettings)
}
</script>
